export const MAX_LISTINGS = 100;
export const MIN_PHOTOS = 3;
export const MAX_PHOTOS = 15;
export const MAX_PHOTO_BYTES = 5 * 1024 * 1024;
export const MAX_PHOTO_DIMENSION = 5000;
export const MAX_PROPERTY_PRICE = 10000;
export const MAX_NIGHTS = 29;
export const MAX_BEDS_BATHS = 30;
export const MAX_TITLE = 250;
export const MAX_DESCRIPTION = 1000;
export const MIN_UNITS = 1;
export const MAX_UNITS = 100;

export const ALLOWED_PHOTO_TYPES = [
  "image/jpeg",
  "image/jpg",
  "image/png",
  "image/webp",
];

export const PHOTO_REQUIREMENTS_EN =
  "File requirements: each photo can be up to 5 MB with a maximum resolution of 5000×5000 pixels. You need at least 3 photos per listing (up to 15).";

export const SAUDI_COUNTRY = {
  en: "Saudi Arabia",
  ar: "المملكة العربية السعودية",
};

export const CHECK_IN_TIME_OPTIONS = [
  "8:00 AM",
  "9:00 AM",
  "10:00 AM",
  "11:00 AM",
  "12:00 PM (noon)",
  "1:00 PM",
  "2:00 PM",
  "3:00 PM",
  "4:00 PM",
  "5:00 PM",
  "6:00 PM",
  "7:00 PM",
  "8:00 PM",
  "9:00 PM",
  "10:00 PM",
  "11:00 PM",
  "12:00 AM (midnight)",
];

export const AVAILABILITY_WINDOWS = [
  { value: "allFutureDates", label: "All future dates" },
  { value: "3Months", label: "3 months" },
  { value: "6Months", label: "6 months" },
  { value: "9Months", label: "9 months" },
  { value: "12Months", label: "12 months" },
  { value: "datesUnavailable", label: "Dates unavailable" },
];

export const ROOM_AMOUNT_OPTIONS = Array.from({ length: 10 }, (_, i) => i + 1);

let listingSeq = 0;
export const nextListingId = () => {
  listingSeq += 1;
  return `listing-${Date.now()}-${listingSeq}`;
};

export const createEmptyListing = (overrides = {}) => ({
  id: nextListingId(),
  open: true,
  mobileNumber: "",
  userId: "",
  accountHint: "",
  accountOk: false,
  totalUnits: "1",
  propertyType: "",
  roomType: "",
  roomAmount: "1",
  personalHome: true,
  guests: "2",
  bedrooms: "1",
  bedsTotal: "1",
  bedTypes: [""],
  bathroomsTotal: "1",
  bathroomTypes: [""],
  street: "",
  apt: "",
  cityEn: "",
  cityAr: "",
  citySelected: false,
  state: "",
  zip: "",
  latlng: "",
  essentials: [],
  safeties: [],
  spaces: [],
  propertyRules: [],
  title: "",
  description: "",
  checkInFrom: "12:00 PM (noon)",
  checkInTo: "10:00 AM",
  cancellationPolicy: "",
  currency: "SAR",
  basePrice: "",
  taxes: "",
  weekendPrice: "",
  weeklyDiscount: "0",
  monthlyDiscount: "0",
  availabilityWindow: "allFutureDates",
  minNights: "1",
  maxNights: "15",
  wifiName: "",
  wifiPassword: "",
  securityDepositEnabled: false,
  securityDepositAmount: "",
  securityDepositNotes: "",
  serverErrors: [],
  ...overrides,
});

export const resizeTypeArray = (arr, size, fallback = "") => {
  const next = Array.isArray(arr) ? arr.slice(0, size) : [];
  while (next.length < size) next.push(fallback);
  return next;
};

export const catalogLabel = (item) =>
  item?.en || item?.ar || item?.id || "";
